export const MESSAGE_TEACHER_POLL_INTERVAL_MS = 60_000;

export const VIEW = {
  LIST: "list",
  THREAD: "thread",
  NEW_THREAD: "newThread",
} as const;
